export default {
    data() {
        return {
            imgUrl: this.imgUrl,
            list: []
        }
    },
    methods: {
        //跳转项目包主页
        toProjectHomePage(id) {

            // me.$store.state.id = res.data.result.token;
            // me.$store.state.shopId = res.data.result.shop_id
            // this.$post('users/profile', { token: this.$store.state.id }).then(res => {
            //     me.$store.state.userId = res.data.result.id;
            //     me.$store.state.name = res.data.result.name;
            //     sessionStorage.setItem("tpid", this.$store.state.id);
            //     sessionStorage.setItem("tpname", this.$store.state.name);
            //     sessionStorage.setItem('tpuserId', this.$store.state.userId);
            //     sessionStorage.setItem('tpshopid', this.$store.state.shopId);

            // 从浏览器缓存中获取用户id，有就赋值
            let userid = sessionStorage.getItem('userid')
            
            if (!this.$isAbnormal(userid)) {
                // // console.log('有id')
                // 根据id获取域名
                this.$post('package/get_package', {
                    id: id
                }).then(res => {
                    let url = res.data.result.url
                    
                    // 本地测试
                    // window.location = url + '/#/pojecthomepage?id=' + userid
                    
                    // 线上
                    window.location = url + '/#/?id=' + userid
                })
            } else {
                // // console.log('没id')
                // 根据id获取域名
                this.$post('package/get_package', {
                    id: id
                }).then(res => {
                    let url = res.data.result.url
                    // console.log(url)
                    
                    // 本地测试
                    // window.location = url + '/#/pojecthomepage'
                    // 线上
                    window.location = url + '/#/'
                })
            }

        },
        // 计算状态
        state(start_stydy_time, end_study_time) {
            let stydy = new Date(start_stydy_time).getTime()
            let end = new Date(end_study_time).getTime()
            let time = new Date().getTime()
            if (time > end) {
                return "已完成"
            } else if (time < end && time > stydy) {
                return "学习中"
            } else {
                return "报名中"
            }
        }
    },
    props: {
        courses: Array,
        course: Object
    },
    mounted() {
        // console.log(this.courses)
        // console.log(this.course)
    },
}